import RouteMap from "./RouteMap";
import { formatArrival, bareDuration, pickupLabel } from "./utils";

// Chrome 60-safe — no ?. / flex gap / backdrop-filter
const PortraitEta = function (props) {
  var s = props.s;
  var pickup = props.pickup;
  var routes = props.routes;
  var error = props.error;
  var single = props.single;
  var onMapLoad = props.onMapLoad;
  var showMap = props.showMap !== false;
  var pickLabel = function (r) {
    if (!r) return "";
    return !showMap && r.fullLabel ? r.fullLabel : r.label;
  };
  var r0 = routes[0];
  var stackGap = s.dotLive.width;
  // map-mode cards, sized against the panel above the map
  var mc = s.nmCards(1, routes.length, s.mapPanelBox.portrait);

  // Full-screen data view — one vertical column, hero ETA in the middle.
  if (!showMap) {
    // 4:9 and narrower can't hold two tiles side by side
    var narrow = s.is49 || s.is39 || s.is210;
    var badge = (
      <span style={s.nmBadge}>
        <span style={s.nmDot} /> Live Traffic ETA
      </span>
    );

    // pickup shown once for the whole list, not repeated per card

    var from = (
      <span style={s.nmFrom}>
        <span style={s.nmFromLabel}>From</span>
        <span style={s.nmFromValue}>{pickupLabel(pickup) || "—"}</span>
      </span>
    );

    if (error) {
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>{badge}</div>
          <div
            style={Object.assign({}, s.nmBody, {
              justifyContent: "center",
              alignItems: "center",
            })}
          >
            <div style={s.nmError}>{error}</div>
          </div>
        </div>
      );
    }

    if (single) {
      var arrival = formatArrival(r0 && r0.durationSecs);
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>{badge}</div>

          <div style={s.nmBody}>
            <div style={s.nmJourney}>
              <div style={s.nmRail}>
                <span style={s.nmRailDot} />
                <span style={s.nmRailLine} />
                <span style={s.nmRailPin} />
              </div>
              <div style={s.nmStops}>
                <div style={s.nmStopLabel}>From</div>
                <div style={s.nmStopValue}>{pickupLabel(pickup) || "—"}</div>
                <div style={s.nmStopGap} />
                <div style={s.nmStopLabel}>To</div>
                <div style={s.nmStopValue}>{pickLabel(r0)}</div>
              </div>
            </div>

            <div>
              <div style={s.nmHeroLabel}>Estimated time</div>
              <div style={s.nmHeroRow}>
                <span style={s.nmHeroValue}>
                  {(r0 && bareDuration(r0.duration)) || "--"}
                </span>
              </div>
              {r0 && r0.traffic ? (
                <span
                  style={Object.assign({}, s.nmPill, {
                    color: r0.traffic.color,
                    marginTop: s.nmStopGap.height,
                  })}
                >
                  <span style={s.nmPillDot} />
                  {r0.traffic.label}
                </span>
              ) : null}
            </div>

            <div
              style={Object.assign({}, s.nmStats, {
                flexDirection: narrow ? "column" : "row",
              })}
            >
              <div
                style={Object.assign(
                  {},
                  s.nmTile,
                  narrow
                    ? { marginRight: 0, marginBottom: s.nmTile.marginRight }
                    : {},
                )}
              >
                <div style={s.nmTileLabel}>Distance</div>
                <div style={s.nmTileValue}>{(r0 && r0.distance) || "--"}</div>
              </div>
              {arrival ? (
                <div style={Object.assign({}, s.nmTile, { marginRight: 0 })}>
                  <div style={s.nmTileLabel}>Arrives</div>
                  <div style={s.nmTileValue}>{arrival}</div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    // one column, one row per destination
    var c = s.nmCards(1, routes.length);
    return (
      <div style={s.nmRoot}>
        <div style={s.nmGlow} />
        <div style={s.nmGlowLow} />
        <div style={s.nmTopBar}>
          {badge}
          {s.nmFromInline ? from : null}
        </div>
        {s.nmFromInline ? null : <div style={s.nmFromRow}>{from}</div>}
        <div style={Object.assign({}, s.nmList, { flexDirection: "column" })}>
          {routes.map(function (r) {
            return (
              <div
                key={r.index}
                style={Object.assign(
                  {},
                  c.card,
                  c.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                )}
              >
                <span
                  style={Object.assign({}, c.accent, {
                    background: r.traffic ? c.railTint : r.color,
                  })}
                />
                <div style={c.label}>{r.label || pickLabel(r)}</div>
                <div style={c.row}>
                  <span style={c.time}>{bareDuration(r.duration)}</span>
                  <span style={c.dist}>{r.distance}</span>
                </div>
                <div style={c.foot}>
                  {r.traffic ? (
                    <span
                      style={Object.assign({}, c.pill, {
                        color: r.traffic.color,
                      })}
                    >
                      <span style={c.pillDot} />
                      {r.traffic.label}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div style={Object.assign({}, s.wrapper, { flexDirection: "column" })}>
      <div style={s.panel}>
        {error ? (
          <span>
            <div style={s.header}>
              <span style={s.badge}>
                <span style={s.dotLive} /> Live Traffic ETA
              </span>
            </div>
            <div style={s.content}>
              <div style={s.error}>{error}</div>
            </div>
          </span>
        ) : single ? (
          <div
            style={Object.assign({}, s.content, {
              justifyContent: s.is89 ? "space-between" : "space-evenly",
            })}
          >
            <span
              style={Object.assign({}, s.badge, {
                fontSize:
                  parseFloat(s.badge.fontSize) *
                    (s.is89
                      ? 1.12
                      : s.is210
                        ? 2.4
                        : s.is49 || s.is39
                          ? 2.08
                          : 1.6) +
                  "px",
              })}
            >
              <span style={s.dotLive} /> Live Traffic ETA
            </span>
            <div
              style={Object.assign({}, s.to, {
                marginTop: 0,
                fontSize:
                  parseFloat(s.mins.fontSize) *
                    (s.is39 ? 1.56 : s.is210 ? 1.5 : 1.3) +
                  "px",
              })}
            >
              To: {pickLabel(r0)}
            </div>
            <div
              style={{
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={Object.assign({}, s.mins, {
                  marginTop: 0,
                  marginBottom: stackGap,
                  fontWeight: 800,
                  fontSize:
                    parseFloat(s.mins.fontSize) *
                      (s.is39 ? 1.56 : s.is210 ? 1.5 : 1.3) +
                    "px",
                })}
              >
                {r0 && r0.duration ? "in " + r0.duration + "." : " "}
              </span>
              {r0 && r0.traffic ? (
                <span
                  style={Object.assign({}, s.trafficPill, {
                    marginTop: 0,
                    fontSize:
                      parseFloat(s.trafficPill.fontSize) *
                        (s.is39 ? 1.56 : s.is210 ? 1.3 : 1) +
                      "px",
                  })}
                >
                  {r0.traffic.label}
                </span>
              ) : null}
            </div>
            <div
              style={Object.assign({}, s.distance, {
                marginTop: 0,
                fontSize:
                  parseFloat(s.distance.fontSize) *
                    (s.is89 ? 0.7 : s.is39 ? 1.44 : s.is210 ? 1.4 : 1) *
                    0.7 +
                  "px",
              })}
            >
              {(r0 && r0.distance) || "--"}
            </div>
          </div>
        ) : (
          <span>
            <div
              style={Object.assign({}, s.header, {
                justifyContent: "center",
              })}
            >
              <span
                style={Object.assign({}, s.badge, {
                  fontSize: parseFloat(s.badge.fontSize) * 1.2 + "px",
                })}
              >
                <span style={s.dotLive} /> Live Traffic ETA
              </span>
            </div>
            <div style={s.list}>
              {routes.map(function (r) {
                return (
                  <div
                    key={r.index}
                    style={Object.assign(
                      {},
                      mc.card,
                      mc.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                    )}
                  >
                    <span
                      style={Object.assign({}, mc.accent, {
                        background: r.traffic ? mc.railTint : r.color,
                      })}
                    />
                    <div style={mc.label}>{pickLabel(r)}</div>
                    <div style={mc.row}>
                      <span style={mc.time}>{bareDuration(r.duration)}</span>
                      <span style={mc.dist}>{r.distance}</span>
                    </div>
                    <div style={mc.foot}>
                      {r.traffic ? (
                        <span
                          style={Object.assign({}, mc.pill, {
                            color: r.traffic.color,
                          })}
                        >
                          <span style={mc.pillDot} />
                          {r.traffic.label}
                        </span>
                      ) : null}
                      <span style={mc.routeChip}>
                        A &rarr; {String.fromCharCode(66 + r.index)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </span>
        )}
      </div>

      {showMap ? (
        <div style={s.mapSide}>
          <RouteMap
            s={s}
            pickup={pickup}
            routes={routes}
            single={single}
            onMapLoad={onMapLoad}
          />
        </div>
      ) : null}
    </div>
  );
};

export default PortraitEta;
